
(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    // 
    //

  function pxWorkstationNetworks(
    $ngBootbox, toastr, $filter, GroupListService, GroupModel, NetworkModel
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        tenant: '=tenant',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/workstationProperties/workstationSettings/workstationNetworks/workstationNetworks.template.html',
      link: function(scope) {

        scope.networks = [];
        

        (function() {
          setNetworksList();
        })();

        function setNetworksList () {
          scope.groupList = [];
          var networks = scope.context.workstation.info._embedded.networks;
          angular.forEach(networks, function (network) {
            var newNetwork = new NetworkModel(network);
            scope.networks.push(newNetwork);
          });
        }


        ////////////////////////////////////////////
        ////////////////////////////////////////////
        // LIST MENU
        ////////////////////////////////////////////
        scope.openListMenu = function (event, queue) {
          var position = document.getElementById(event.target.id).getBoundingClientRect();
          setTimeout(function () {
            scope.closeListMenu();
            scope.listMenuContext = queue;
            scope.listMeta = {
              position: {left: position.x, top: position.y},
              parentId: event.target.id,
              type: 'nestedNetworkList',
              scrollContainerId: 'GroupScrollContainer'
            }
            scope.$apply();
          }, 50)
        }

        scope.closeListMenu = function (group, action) {
          scope.listMenuContext = null;
          scope.listMeta = null;

          switch (action) {
            case 'REMOVE_GROUP':
              scope.removeGroup(group);
            break;
          }
        }

        scope.addNetworks = function (event) {
          scope.callback({context: 
            {
              groups : scope.context.groups, 
              link: scope.context.link, 
              workstation: scope.context.workstation,
              event: event,
              type: 'addToNetwork', 
              dontUseTitle: false, 
              dontUseName: true, 
              exclude: scope.context.exclude,
              securityLevel: scope.context.securityLevel ?  scope.context.securityLevel : null,
              title: 'AddToNetwork',
              name: scope.context.name}});
        }
      }
    };
  }

  pxWorkstationNetworks.$inject = ['$ngBootbox', 'toastr', '$filter', 'GroupListService', 'GroupModel', 'NetworkModel'];

  angular
    .module('printix-admin')
    .directive('pxWorkstationNetworks', pxWorkstationNetworks);

})();
